import { Canvas, Camera, useFrame } from "@react-three/fiber";
import { OrbitControls, Stage, useGLTF } from "@react-three/drei";
import React, { useRef, Suspense, useState, useEffect, Component } from "react";
import { lookAt, wobble } from "../utils/animations";
import { HashLink as Link } from "react-router-hash-link";
import { Helmet } from "react-helmet";
import ScrollIntoView from "react-scroll-into-view";

import TypeWriterEffect from "react-typewriter-effect";

function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF("/webthin.glb");

  useFrame((state) => {
    const { position, rotation } = group.current;
    position.y += wobble(state) / 8000;
    position.x += wobble(state) / 8000;

    rotation.y += wobble(state) / 30000;
    rotation.x += wobble(state) / 30000;
    rotation.z += wobble(state) / 30000;

    rotation.y = lookAt(state, rotation.y);
    rotation.x = lookAt(state, rotation.x);
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        receiveShadow
        geometry={nodes["1"].geometry}
        material={materials.Material}
        rotation={[Math.PI / 2, 0, 0]}
        position={(1, 1, 1, -1)}
      />
    </group>
  );
}
useGLTF.preload("/webthin.glb");

class Home extends React.Component {
  render() {
    return (
      <>
        <div className="wrap">
          <Suspense>
            <Canvas
              className="objectresize"
              camera={{ position: [0, -25, 50.25], fov: 18 }}
              gl={{
                powerPreference: "low-power",
                stencil: false,
                depth: true,
                preserveDrawingBuffer: false,
                premultipliedAlpha: true,
              }}
              style={{
                left: 0,
                top: 0,
                right: 0,
                position: "absolute",
              }}
            >
              <Model />
              {/* </Stage> */}
            </Canvas>
          </Suspense>
        </div>

        <main>
          <div className="LeftLogo">
            <div id="text">
              <TypeWriterEffect
                className="headertext"
                textStyle={{
                  fontFamily: "Fira Code",
                  width: "7",
                  color: "#eef7ed",
                  fontWeight: 100,
                }}
                startDelay={1000}
                cursorColor="#eef7ed"
                multiText={[
                  "by Stefani Pletenetska",
                  " ",
                  "by Stefani Pletenetska",
                  " ",
                  "by Stefani Pletenetska",
                  " ",
                  "by Stefani Pletenetska",
                  " ",
                  "by Stefani Pletenetska",
                  " ",
                  "by Stefani Pletenetska",
                  " ",
                  "by Stefani Pletenetska",
                ]}
                loop={true}
                nextTextDelay={900}
                typeSpeed={110}
              />
            </div>
          </div>

          <div className="ButtonMenu">
            <ScrollIntoView selector="#about" className="Menu">
              <button>
                {/* <Link to="#about" className="Menu"> */}
                &#60;About&#62;
                {/* </Link> */}
              </button>
            </ScrollIntoView>
            <ScrollIntoView selector="#work" className="Menu">
              <button>
                {/* <a className="Menu" href="#work"> */}
                &#60;Work&#62;
                {/* </a> */}
              </button>
            </ScrollIntoView>
            <ScrollIntoView selector="#contact" className="Menu">
              <button>
                {/* <a className="Menu" href="#contact"> */}
                &#60;Contact&#62;
                {/* </a> */}
              </button>
            </ScrollIntoView>
          </div>
        </main>

        <div className="mainbody">
          <span className="anchor">
            <section id="about">
              <div className="about">
                <h2>[ABOUT]</h2>
                <p>
                  I'm an artist and designer from Ukraine, focusing on combining{" "}
                  <br />
                  seemingly unrelated concepts into captivating objects and
                  <br />
                  visuals, while navigating the personal and the present.
                </p>
              </div>
            </section>
          </span>
          <div className="workborder">
            <div id="work">
              <div className="buttonmenutext">
                <Link to="../Project1#workdescriptionpr">
                  <div class="image-text__title">
                    <h3 class="image-text-home1">
                      <span className="smallnumber">01</span>PRAY.img
                    </h3>
                  </div>
                </Link>
                <Link to="../Project3#workdescription">
                  <div class="hover-cursor">
                    <h3 class="image-text-home3">
                      <span className="smallnumber">02</span>BLESS.cur
                    </h3>
                  </div>
                </Link>
                <Link to="../Project4#workdescription">
                  <div class="image-text__title">
                    <h3 class="image-text-home4">
                      <span className="smallnumber">03</span>README.txt
                    </h3>
                  </div>
                </Link>
                <Link to="../Project2#workdescription">
                  <div class="image-text__titleimage-text-home2">
                    <h3 class="image-text-home2">
                      <span className="smallnumber">04</span>SYNTH
                    </h3>
                  </div>
                </Link>
                {/* <Link to="../CAD#workdescription">
                  <div class="image-text__title">
                    <h3 class="image-text-home5">
                      <span className="smallnumber">05</span>COMINGSOON
                    </h3>
                  </div>
                </Link> */}
                <Link to="../Misc#centered">
                  <div class="image-text__title">
                    <h3 class="image-text-home6">
                      <span className="smallnumber">05</span>MISC
                    </h3>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <footer id="connect">
            <span id="contact">
              <div className="footer">
                <section>
                  <h2>[Contact]</h2>
                  <p>stefani.contact.me@gmail.com</p>
                  <div className="Links">
                    <div>
                      <a
                        className="socials"
                        href="https://www.instagram.com/wakeupstefani"
                        target="_blank"
                      >
                        INSTAGRAM
                      </a>
                    </div>
                    <div>
                      <a
                        className="socials"
                        href="https://www.youtube.com/channel/UCgqIjHXkqNJFnOESi7GL0Bg"
                        target="_blank"
                      >
                        YOUTUBE
                      </a>
                    </div>
                  </div>
                </section>
              </div>
            </span>
          </footer>
        </div>
      </>
    );
  }
}

export default Home;
